import React from "react";
import { useTranslation } from "react-i18next";
import { AssetCategory } from "velavu-js-api";
import ConnectionStatus from "../data/connection-status";
import iconEquipment from "../img/icons/icon-equipment.svg";
import iconVehicle from "../img/icons/icon-vehicle.svg";
import iconPerson from "../img/icons/icon-person.svg";
import StatusIndicator from "./status-indicator";
import * as styles from "./velavu-item-icon.module.scss";
import { useDeviceModels } from "../components/main/device-model-provider";
import { mapCategoryName } from "../data/asset-categorization";

export type VelavuItemIconData =
	| {
			//A device model
			model: string | undefined;
	  }
	| {
			//An asset category
			category: AssetCategory;
	  }
	| {
			//A remote URL
			url: string;
	  };

/**
 * An element that is used to represent an asset, tag, or anchor
 * @param props.data The type of icon to display, or a URL to display a custom image
 * @param props.status The connection status indicator to display, or UNDEFINED to hide
 */
export default function VelavuItemIcon(props: {
	data: VelavuItemIconData;
	status?: ConnectionStatus;
}) {
	const { t } = useTranslation();
	const { getDeviceModel } = useDeviceModels();

	const data = props.data;
	let imgSrc: string | undefined = undefined;
	let className = "";
	let alt: string | undefined = undefined;

	if ("category" in data) {
		switch (data.category) {
			case AssetCategory.Vehicle:
				imgSrc = iconVehicle;
				className = styles.iconAsset;
				break;
			case AssetCategory.Equipment:
				imgSrc = iconEquipment;
				className = styles.iconAsset;
				break;
			case AssetCategory.Person:
				imgSrc = iconPerson;
				className = styles.iconAsset;
				break;
		}
		alt = mapCategoryName(data.category, t);
	} else if ("model" in data) {
		imgSrc = getDeviceModel(data.model)?.images?.thumbnail;
		className = styles.iconDevice;
		alt = data.model;
	} else {
		imgSrc = data.url;
		className = "";
	}

	return (
		<div className={`${styles.main} ${className}`}>
			<img className={styles.size} src={imgSrc} alt={alt} />

			{props.status && (
				<span className={styles.indicator}>
					<StatusIndicator status={props.status} />
				</span>
			)}
		</div>
	);
}
